import { compose, withHandlers, withProps } from 'recompose'
import { connect } from 'react-redux'
import withType from 'components/common/hoc/withType'
import BOTStoreContactPage from './BOTStoreContactPage'
import { getCurrentStorePhoneNumber } from 'selectors/getCurrentStore'
import withRequestApptClick from 'components/common/hoc/withRequestApptClick'
import { showStoreLocatorModalInAppointmentMode } from 'actions/storeLocator'

const mapStateToProps = (state) => ({
  storePhoneNumber: getCurrentStorePhoneNumber(state)
})

const withContactStoreHandlers = withHandlers({
  simulateCall: ({ storePhoneNumber }) => () => {
    if (window) {
      window.open(`tel:+1${storePhoneNumber}`, '_self')
    }
  },
  handleStoreLocationClick: ({ showStoreLocatorModalInAppointmentMode }) => (e) => {
    e.stopPropagation()
    showStoreLocatorModalInAppointmentMode()
  }
})

export default compose(
  withType({ type: ['BOTStoreContactSERPPage', 'BOTStoreContactBrandPage', 'BOTStoreContactPage']}),
  connect(mapStateToProps, { showStoreLocatorModalInAppointmentMode }),
  withProps(() => ({ navigateToQuickApptPage: true })),
  withRequestApptClick,
  withContactStoreHandlers
)(BOTStoreContactPage)
